import { render, staticRenderFns } from "./ModalContactForm.vue?vue&type=template&id=20500c25&"
import script from "./ModalContactForm.vue?vue&type=script&lang=js&"
export * from "./ModalContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports